import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, Carousel, Glyphicon } from "react-bootstrap";
import "../MainPage/MainPage.scss";
import { getTestimonials } from "../../actions/AdminActions";

class Testimonials extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: [],
      filterComments: [],
    };
    props.dispatch(getTestimonials(this.getTestimonials));
  }
  getTestimonials = (comments, message) => {
    this.setState({ comments, filterComments: comments });
  };
  render() {
    return (
      <div
        className="testi-wrap"
        // style={{ paddingBottom: '60px' }}
      >
        <section
          className="testimonial-section bg-default-liac"
          id="testimonial-section"
          style={{ padding: "40px 0px" }}
        >
          <div>
            <h1 className="titlenames">Testimonials</h1>
            <hr className="divider-hr" />
          </div>
          <div className="container">
            <Row className="align-items-center">
              {/* <Col lg={4} md={4} sm={6} md={6} className="testimonial-left">
                <h2>What People Say</h2>
                <p>
                  Our customers are extremely satisfied with our services. Lets
                  hear it from them.
                </p>
              </Col> */}
              <Col
                lg={12}
                md={12}
                sm={12}
                md={12}
                className="testimonial-right"
              >
                <Carousel
                  className="testi-carousel"
                  // prevIcon={
                  //   <Glyphicon
                  //     glyph="chevron-left"
                  //     className="glyphicon glyphicon-menu-left"
                  //   />
                  // }
                  // nextIcon={
                  //   <Glyphicon
                  //     glyph="chevron-left"
                  //     className="glyphicon glyphicon-menu-right"
                  //   />
                  // }
                >
                  <Row>
                    {this.state.comments.map((val) => {
                      return (
                        <Carousel.Item>
                          <Col lg={12} md={12} sm={12} xs={12}>
                            <div className="single-testimonial item">
                              <p>“{val.comment}”</p>
                              <div className="user-details d-flex flex-row align-items-center">
                                <div className="details">
                                  <h4>{val.name} </h4>
                                </div>
                              </div>
                            </div>
                          </Col>
                          {/* <Col lg={4} md={4} sm={4} md={12}>
                        <div className="single-testimonial item">
                          <p>
                            “They helped us with application and technology analysis
                            to improve IT operational Excellence and margins.”
                          </p>
                          <div className="user-details d-flex flex-row align-items-center">
                            <div className="details">
                              <h4>Rama Burugula</h4>
                              <p>Management Consultant, India </p>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col lg={4} md={4} sm={4} md={4}>
                        <div className="single-testimonial item">
                          <p>
                            “Very innovative, trendy and modern web site for our
                            company. Simply superb.”
                          </p>
                          <div className="user-details d-flex flex-row align-items-center">
                            <div className="details">
                              <h4>Debjyoti Das</h4>
                              <p>Program Manager, India</p>
                            </div>
                          </div>
                        </div>
                      </Col> */}
                        </Carousel.Item>
                      );
                    })}
                  </Row>

                  {/* <Carousel.Item>
                    <Row>
                      <Col lg={4} md={4} sm={4} md={12}>
                        <div className="single-testimonial item">
                          <p>
                            “Provided scable technology solutions for online
                            business solutions. Extremely taleneted team.”
                          </p>
                          <div className="user-details d-flex flex-row align-items-center">
                            <div className="details">
                              <h4>Amber Mcdonald</h4>
                              <p>Technology Architect</p>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Carousel.Item> */}
                </Carousel>
              </Col>
            </Row>
          </div>
        </section>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userInfo: state.users.userInfo,
    currentLanguage: state.users.currentLanguage,
  };
}

export default connect(mapStateToProps)(Testimonials);



// WEBPACK FOOTER //
// ./screens/MainPage/Testimonials.js